/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';
import type { EmployeeProjection } from './EmployeeProjection';
import {
    EmployeeProjectionFromJSON,
    EmployeeProjectionFromJSONTyped,
    EmployeeProjectionToJSON,
    EmployeeProjectionToJSONTyped,
} from './EmployeeProjection';

/**
 * 
 * @export
 * @interface UserConnectedProjection
 */
export interface UserConnectedProjection {
    /**
     * 
     * @type {number}
     * @memberof UserConnectedProjection
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof UserConnectedProjection
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UserConnectedProjection
     */
    email?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserConnectedProjection
     */
    partnerId?: number | null;
    /**
     * 
     * @type {Company}
     * @memberof UserConnectedProjection
     */
    companyId?: Company | null;
    /**
     * 
     * @type {EmployeeProjection}
     * @memberof UserConnectedProjection
     */
    employeeId?: EmployeeProjection | null;
}

/**
 * Check if a given object implements the UserConnectedProjection interface.
 */
export function instanceOfUserConnectedProjection(value: object): value is UserConnectedProjection {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserConnectedProjectionFromJSON(json: any): UserConnectedProjection {
    return UserConnectedProjectionFromJSONTyped(json, false);
}

export function UserConnectedProjectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserConnectedProjection {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'] == null ? undefined : json['email'],
        'partnerId': json['partner_id'] == null ? undefined : json['partner_id'],
        'companyId': json['company_id'] == null ? undefined : CompanyFromJSON(json['company_id']),
        'employeeId': json['employee_id'] == null ? undefined : EmployeeProjectionFromJSON(json['employee_id']),
    };
}

export function UserConnectedProjectionToJSON(json: any): UserConnectedProjection {
    return UserConnectedProjectionToJSONTyped(json, false);
}

export function UserConnectedProjectionToJSONTyped(value?: UserConnectedProjection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'partner_id': value['partnerId'],
        'company_id': CompanyToJSON(value['companyId']),
        'employee_id': EmployeeProjectionToJSON(value['employeeId']),
    };
}

